import { Dispatch, useEffect, useState } from "react";
import "./CasinoGameThumbnail.scss";
import { RouteComponentProps, withRouter } from "react-router";
import { prettyUrl } from "../../utils/UrlUtils";
import { CasinoGameInfo, CasinoGameInfo as CasinoGame, CasinoGameTranslation, CasinoStudio, Style, GameDisplay, AppMode } from "../../http/protocol";
import Translator, { Translation } from "../../Translator";
import BackgroundUrlTranslator from "../../BackgroundUrlTranslator";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../RootReducer";
import { getJackpotAmountByGame } from "../../selectors/casino-selectors";
import { selectMobilePreviewGame } from "../../navigation/NavigationActions";
import { setCategoryLayout } from "../CasinoActions";

interface Props extends RouteComponentProps {
  game: CasinoGame;
  isMobile?: boolean;
  variant?: Style;
  numberOfGamesInRow?: number | null;
  loggedIn?: boolean;
  updateSearchValue: (str: string) => void;
  favourite?: boolean;
  toggleFavourite: (game: CasinoGameInfo) => void;
  compact?: boolean;
  studios?: { [p: string]: CasinoStudio };
}

const launchGame = (e: any, props: Props, dispatch: Dispatch<any>) => {
  if (props.isMobile) {
    dispatch(selectMobilePreviewGame(props.game));
    return;
  }
  if (e.target?.className.indexOf("favourite-icon") != -1) {
    return;
  }

  if (props.updateSearchValue) {
    props.updateSearchValue("");
  }
  launch(props.game, props.loggedIn, props.history);
};
export const launch = (game?: CasinoGameInfo, loggedIn?: boolean, history?: any) => {
  if (game?.name && game?.display == GameDisplay.EMBEDDED) {
    history?.push(`/casino/originals/${game.id}/${prettyUrl(game.name)}`);
  } else if (game?.name) {
    let fun = "";
    if (!loggedIn && game.playForFun) {
      fun = "/fun";
    }
    history?.push(`/casino/play/${game.id}/${prettyUrl(game.name)}${fun}`);
  }
};
export const launchMobile = (game?: CasinoGameInfo, playForFun?: boolean, history?: any) => {
  if (game?.name && game?.display == GameDisplay.EMBEDDED) {
    history?.push(`/casino/originals/${game.id}/${prettyUrl(game.name)}`);
  } else if (game?.name) {
    let fun = "";
    if (game.playForFun && playForFun) {
      fun = "/fun";
    }
    history?.push(`/casino/play/${game.id}/${prettyUrl(game.name)}${fun}`);
  }
};
function getClassNames(compact?: boolean) {
  if (compact) {
    return "casino-game small";
  } else {
    return "casino-game";
  }
}
export function mapTranslations(g?: CasinoGame): Translation[] {
  if (!g || !g.translations) {
    return [];
  }
  return g.translations.map((t: CasinoGameTranslation) => ({ lng: t.language, value: t.imageUrl }));
}

export const CasinoGameThumbnail = (props: Props) => {
  const isMobile = useSelector((app: AppState) => app.settings.mobile);

  let dispatch = useDispatch();
  let numbersOf = props.numberOfGamesInRow ? props.numberOfGamesInRow : null;
  const [style, setStyle] = useState({});

  useEffect(() => {
    const updateStyle = () => {
      if (numbersOf != null && window.innerWidth > 992) {
        setStyle(new setCategoryLayout(numbersOf));
      } else if (numbersOf != null && window.innerWidth < 992) {
        setStyle(new setCategoryLayout(Math.floor(numbersOf / 2)));
      } else if (numbersOf != null && window.innerWidth < 576) {
        setStyle(new setCategoryLayout(Math.floor(numbersOf / 2)));
      } else {
        setStyle({});
      }
    };

    updateStyle();
    window.addEventListener("resize", updateStyle);

    return () => {
      window.removeEventListener("resize", updateStyle);
    };
  }, [numbersOf]);

  const jackpot = useSelector((app: AppState) => getJackpotAmountByGame(app, props.game.id ?? -1));
  return (
    <div style={style} className={`${isMobile ? "casino-game mobile" : getClassNames(props.compact)}`}>
      <div className={"game-box"}>
        <div className="content" onClick={(e) => launchGame(e, { ...props, isMobile: isMobile }, dispatch)}>
          <div className={"content-overlay"}></div>
          <BackgroundUrlTranslator className={"thumbnail thumb-bg"} defaultTranslation={props.game.imageUrl} translations={mapTranslations(props.game)}>
            <div className={"play-now"}>
              <div className={"game-description"}>
                <div className={"game-text-container"}>
                  <div className={"content game-name"}>{props.game && props.game.name && <Translator defaultTranslation={props.game.name} translations={(props.game.translations ?? []).map((t) => ({ lng: t.language, value: t.name })) as any} />}</div>
                  <div className={"meta"}>
                    <div className={"provider"}>{props.game && props.studios?.["" + props.game.studioId]?.name}</div>
                  </div>
                </div>

                <div className={"favourite-container"} onClick={() => props.game && props.game.id && props.toggleFavourite && props.toggleFavourite(props.game)}>
                  {!props.favourite && (
                    <a className={"favourite"}>
                      <i className={"material-icons favourite-icon"}>favorite_border</i>
                    </a>
                  )}
                  {props.favourite && (
                    <a className={"favourite selected"}>
                      <i className={"material-icons favourite-icon"}>favorite</i>
                    </a>
                  )}
                </div>
              </div>
              <div className={"game-play-button"}>
                <span className={"click-to-play"}>
                  <i className={"material-icons"}>play_circle_filled</i>
                </span>
              </div>
            </div>
          </BackgroundUrlTranslator>
          {jackpot && (
            <div className={"jackpot-container"}>
              <div className={"jackpot-amount"}>{jackpot}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter<Props, any>(CasinoGameThumbnail);
